import { SVGProps, Ref, forwardRef } from 'react';

export const CartOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m13.785 3.092 3.743 4.904H6.472l3.743-4.904L8.785 2 4.207 7.996H0l.736 7.467h.002c.56 4.892 2.695 6.533 8.379 6.533h5.766c5.684 0 7.818-1.641 8.379-6.533h.002L24 7.996h-4.207L15.215 2zM2.526 15.26c.259 2.254.834 3.3 1.585 3.884.82.637 2.255 1.053 5.006 1.053h5.766c2.751 0 4.187-.416 5.006-1.053.751-.584 1.326-1.63 1.585-3.885l.54-5.462H1.986z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CartOutlinedSize24Glyph.displayName = 'CartOutlinedSize24Glyph';
